module.exports = __webpack_public_path__ + "static/form-to-instant-demo-0a808413df4a62daaee87361e7ec3f2c.gif";